import { CompensationType } from 'enums';

export const CONSENT_REQUIRED_TYPES: CompensationType[] = [CompensationType.Medical, CompensationType.Robotics];

interface ConsentFieldPolicyParams {
  requiresConsentType: boolean;
  isUserMode?: boolean;
  isNew?: boolean;
  privacyConsent?: boolean;
}

export const getConsentFieldPolicy = ({
  requiresConsentType,
  isUserMode,
  isNew,
  privacyConsent,
}: ConsentFieldPolicyParams) => ({
  isRequired: !!isUserMode && requiresConsentType,
  isDisabled: !isUserMode || (!isNew && !!privacyConsent),
});

export const getConsentTextKeys = (type?: CompensationType) => {
  switch (type) {
    case CompensationType.Robotics:
      return {
        label: 'consentLabelRobotics',
        purpose: 'consentNotePurposeRobotics',
        data: 'consentNoteDataRobotics',
        law: 'consentNoteLawRobotics',
      };
    case CompensationType.Medical:
    default:
      return {
        label: 'consentLabel',
        purpose: 'consentNotePurpose',
        data: 'consentNoteData',
        law: 'consentNoteLaw',
      };
  }
};
